import { dcFactory } from '@deleteagency/dc';
import SearchDetailsCollapsedComponent from './js/search-details-collapsed.component';
import SearchEditTriggerComponent from './js/search-edit-trigger.component';
import SearchLayoutComponent from './js/search-layout.component';
import SearchMapComponent from './js/search-map.component';
import SearchMetaComponent from './js/search-meta.component';
import SearchOrderComponent from './js/search-order.component';
import SearchResultGalleryComponent from './js/search-result-gallery.component';
import './scss/index.scss';

dcFactory.register(SearchMetaComponent);
dcFactory.register(SearchLayoutComponent);
dcFactory.register(SearchDetailsCollapsedComponent);
dcFactory.register(SearchOrderComponent);
dcFactory.register(SearchMapComponent);
dcFactory.register(SearchEditTriggerComponent);
dcFactory.register(SearchResultGalleryComponent);
